import * as React from 'react';

export type DirtyContextProps = {
  setDirty(dirty: boolean);
};

export const DirtyContext = React.createContext<DirtyContextProps>({ setDirty : _f => {
  // no-op
}});
